import React, { useState, useContext, useEffect } from "react";
import { View, ScrollView, TouchableOpacity } from "react-native";
import ThemeContext from "@presto-contexts/ThemeContext";
import { VerticalSpacing } from "@presto-components/Spacing";
import LoadingContainer from "@presto-components/LoadingContainer";
import _ from "lodash";
import Spring from "@presto-components/Spring/Spring";
import TitleHeaderWithBack from "@presto-components/Headers/TitleHeaderWithBack";
import { useSafeArea, SafeAreaView } from "react-native-safe-area-context";
import { LineDivider } from "@presto-components/Dividers/Dividers";
import GalleryManager from "@presto-services/features/gallery/GalleryManager";
import asyncify from "../../common/Asyncify";
import SearchManager from "@presto-services/features/search/SearchManager";
const AsyncGalleryManager = asyncify(GalleryManager);
import I18n from "i18n-js";
import PrestoText from "@presto-components/PrestoText";
import {
  PrestoSolidButton,
  PrestoFramedButton,
} from "@presto-components/PrestoButton";
import TitleHeaderWithBackWithGradientBackground from "@presto-screen-components/Headers/TitleHeaderWithBackWithGradientBackground";
import UserContext from "@presto-contexts/UserContext";
import utils from "../../utils";
import RightPaneContext from "@presto-contexts/RightPaneContext";

export default function FilterOptionsMedicineScreen({ route, navigation }) {
  const {
    selectedMedicineType,
    onFilterChange,
    allMedicineType,
    showClear = false,
    showInDesktop = false,
  } = route.params;
  const { theme } = useContext(ThemeContext);
  const { user } = useContext(UserContext);
  const [close, setClose] = useState(false);
  const [medicineTypes, setMedicineTypes] = useState([]);
  const { rightPaneOpen, setPaneState } = useContext(RightPaneContext);
  const [chosenMedicineType, setChosenMedicineType] = useState(
    selectedMedicineType
  );

  useEffect(() => {
    if (allMedicineType) {
      setMedicineTypes(allMedicineType);
    } else {
      SearchManager.getZipHealthFilteredOtherDataAttributes(
        {},
        "form",
        (response) => {
          setMedicineTypes(response.aggregations.distinct_form.buckets);
        },
        (error) => {}
      );
    }
  }, []);

  const chooseMedicineType = (man) => {
    setChosenMedicineType(man);
  };

  const onApply = () => {
    onFilterChange({
      form: chosenMedicineType,
    });
    if (utils.isDesktop()) {
      setPaneState(false);
    } else {
      navigation.goBack();
    }
  };

  const handleClear = () => {
    onFilterChange({
      form: null,
    });
    if (utils.isDesktop()) {
      setPaneState(false);
    } else {
      navigation.goBack();
    }
  };

  const renderActionSheet = ({ margin }) => {
    return (
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: theme.white,
        }}
      >
        <LoadingContainer bgColor={theme.white} loading={false}>
          <SafeAreaView
            style={{
              backgroundColor: theme.white,
              marginBottom: margin,
              flex: 1,
            }}
          >
            {!showInDesktop && (
              <TitleHeaderWithBackWithGradientBackground
                user={user}
                title={I18n.t("screen_messages.common.filter")}
              />
            )}
            <View
              style={{
                flexDirection: "row",
                justifyContent: showClear ? "space-between" : "flex-end",
                paddingHorizontal: theme.primaryPadding,
                // paddingRight: theme.primaryPadding,
                marginVertical: 20,
              }}
            >
              {showClear && (
                <TouchableOpacity onPress={handleClear}>
                  <PrestoText
                    fontStyle={"semibold"}
                    color={theme.primary}
                    size={16}
                    extraStyle={{ textDecorationLine: "underline" }}
                  >
                    {I18n.t("screen_messages.clear")}
                  </PrestoText>
                </TouchableOpacity>
              )}
              <PrestoFramedButton
                buttonStyle="primary"
                size="normal"
                width={80}
                title={I18n.t("screen_messages.common.apply")}
                onPress={onApply}
              />
            </View>

            <ScrollView
              contentContainerStyle={{
                paddingHorizontal: theme.primaryPadding,
                flex: 1,
                flexDirection: "column",
              }}
            >
              <PrestoText
                fontStyle={"semibold"}
                color={theme.primary}
                size={16}
              >
                {I18n.t("screen_messages.medicine_type")}
              </PrestoText>
              <LineDivider dividerColor="#DADADA" width="100%" theme={theme} />
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginTop: 10,
                }}
              >
                {_.map(medicineTypes, (manufacturer) => {
                  if (chosenMedicineType !== manufacturer.key) {
                    return (
                      <View
                        style={{
                          paddingRight: 10,
                          marginBottom: 10,
                        }}
                      >
                        <PrestoFramedButton
                          buttonStyle="primary"
                          size="normal"
                          width="100%"
                          title={manufacturer.key}
                          onPress={() => chooseMedicineType(manufacturer.key)}
                        />
                      </View>
                    );
                  } else {
                    return (
                      <View
                        style={{
                          paddingRight: 20,
                          marginBottom: 10,
                          marginRight: 10,
                        }}
                      >
                        <PrestoSolidButton
                          size="normal"
                          width="120%"
                          titleColor={theme.white}
                          buttonStyle="primary"
                          titleFontStyle="700.bold"
                          title={manufacturer.key}
                          extraStyle={{
                            paddingHorizontal: 10,
                          }}
                          onPress={() => chooseMedicineType(manufacturer.key)}
                        />
                      </View>
                    );
                  }
                })}
              </View>
              <VerticalSpacing size={40} />
            </ScrollView>
          </SafeAreaView>
        </LoadingContainer>
      </ScrollView>
    );
  };

  const fromSpring = close ? { margin: 0 } : { margin: -600 };
  const toSpring = close ? { margin: -600 } : { margin: 0 };

  return (
    <Spring from={fromSpring} to={toSpring}>
      {(props) => renderActionSheet(props)}
    </Spring>
  );
}
